import * as React from "react";

const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "oldQuantity",
            label: t ? t("forms.current_state") : "Obecny stan",
            type: "number",
            mandatory: true,
            readOnly: true,
            column: 1,
        },
        {
            name: "addQuantity",
            label: t ? t("forms.issued_quantity") : "Wydawana ilość",
            type: "number",
            mandatory: true,
            validate: {
                compareWith: "quantity",
                compare: function (addQuantity, quantity) {


                    if (!isNaN(parseInt(addQuantity)) && !isNaN(parseInt(quantity))) {
                        return parseInt(addQuantity) > 0 && parseInt(quantity) >= 0;
                    }

                    return false;

                }
            },
            column: 1,
        },
        {
            name: "quantity",
            label: t ? t("forms.state_after_issue") : "Stan po wydaniu",
            readOnly: true,
            column: 1,
            autoComplete: {
                triggers: ["oldQuantity", "addQuantity"],
                calculation: function (oldQuantity, addQuantity) {
                    if (!isNaN(parseInt(oldQuantity)) && !isNaN(parseInt(addQuantity))) {
                        return parseInt(oldQuantity) - parseInt(addQuantity);
                    }

                    return "";

                }
            }
        },
        {
            name: "comment",
            label: t ? t("common.comment") : "Komentarz",
            type: "textarea",
            column: 1,
        },

    ]
});

export default fields;
